import React, { Component } from 'react';
import { Chart } from 'react-google-charts';
import theme from "../Theme";
import { translate } from "../../i18n/customI18nProvider";
import { formatCurrency } from "../../util";

const graph_colors = [
    theme.palette.primary.main,
    theme.palette.primary.light,
    theme.palette.primary.dark
];

const titleTextStyle = {
    color: theme.palette.primary.main,
    fontSize: 24,
    bold: true,
};

class ConsumptionsColumnChart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currencyCode: props.currencyCode,
            currencySymbol: props.currencySymbol,
        }
    }

    render() {

        let currency = this.state.currencySymbol ? this.state.currencySymbol : this.state.currencyCode;
        const { barsDebit } = this.props;

        if (barsDebit && barsDebit.length > 1) {
            let barsDebitFormatted = [[translate('custom.debits'), translate('custom.amount'), { role: 'annotation' }]];
            for (let i = 0; i < barsDebit.length; i++) {
                barsDebitFormatted.push([barsDebit[i]['name'], {v: parseFloat(barsDebit[i]['total']), f: formatCurrency(parseFloat(barsDebit[i]['total']))}, formatCurrency(parseFloat(barsDebit[i]['total']))]);
            }

            const maxVal = Math.max(...barsDebit.map(b => parseFloat(b.total) || 0));
            const vAxisMax = maxVal * 1.25;

            let view = (
                <Chart
                    chartType="ColumnChart"
                    width="100%"
                    height="350px"
                    data={barsDebitFormatted}
                    options={{
                        title: translate('custom.consumptions'),
                        titleTextStyle,
                        vAxis: {
                            title: translate('custom.amount') + ' (' + currency + ')',
                            format: 'short',
                            viewWindow: {
                                min: 0,
                                max: vAxisMax
                            }
                        },
                        chartArea: {
                            top: 50,
                            height: '70%',
                            width: '80%'
                        },
                        legend: { position: "none" },
                        colors: graph_colors,
                        backgroundColor: { fill: 'transparent' },
                        annotations: {
                            alwaysOutside: true,
                            textStyle: {
                                bold: true,
                                color: theme.palette.primary.main,
                            },
                        }
                    }}
                    graph_id="DebitChart"
                />
            );

            return (
                <div className="breakBefore">
                    {view}
                </div>
            );

        }
        return null;
    }
}

export default ConsumptionsColumnChart;